// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1K3M3","title":"AfterBackImages_title__gzJpi","images":"AfterBackImages_images__3ce08"};